import FooterMega from '../components/shared/global-footer/FooterMega.vue';
import router from '@/routers';
import { createApp } from 'vue';

const mountFooterMega = () => {
  const mountEl = document.getElementById('footer-mega');
  if (!mountEl || mountEl.dataset.vueMounted === 'true') return;

  const app = createApp(FooterMega);
  app.use(router);
  app.mount(mountEl);
  mountEl.dataset.vueMounted = 'true';
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountFooterMega, { once: true });
} else {
  mountFooterMega();
}
